document.addEventListener('DOMContentLoaded',function(){

  if( document.querySelectorAll('[data-component="image-comparison-slider"]').length > 0 ){
    const imageComparisonSlider = document.querySelector('[data-component="image-comparison-slider"]')
    function setSliderstate(e, element) {
        const sliderRange = element.querySelector('[data-image-comparison-range]');
        if (e.type === 'input') {
            sliderRange.classList.add('image-comparison__range--active');
            return;
        }
        element.removeEventListener('mousemove', moveSliderThumb);
    }
    function moveSliderThumb(e) {
        const sliderRange = document.querySelector('[data-image-comparison-range]');
        const thumb = document.querySelector('[data-image-comparison-thumb]');
        let position = e.layerY - 20;
        if (e.layerY <= sliderRange.offsetTop) {
            position = -20;
        }
        if (e.layerY >= sliderRange.offsetHeight) {
            position = sliderRange.offsetHeight - 20;
        }
         thumb.style.top = `${position}px`;
    }
    function moveSliderRange(e, element) {
      const value = e.target.value;
      const slider = element.querySelector('[data-image-comparison-slider]');
      const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');
      slider.style.left = `${value}%`;
      imageWrapperOverlay.style.width = `${value}%`;
      element.addEventListener('mousemove', moveSliderThumb);
      setSliderstate(e, element);
      if(slider.style.left == '100%'){
        document.querySelector('.image-comparison__slider-wrapper').classList.add('AfterTxtActive');
        document.querySelector('.image-comparison__slider-wrapper').classList.remove('BeforeTxtActive');
      }else if(slider.style.left < '52%' || slider.style.left == '9%' || slider.style.left == '8%' || slider.style.left == '7%' || slider.style.left == '6%' ){
        document.querySelector('.image-comparison__slider-wrapper').classList.remove('AfterTxtActive');
        document.querySelector('.image-comparison__slider-wrapper').classList.add('BeforeTxtActive');
      }else if(slider.style.left > '52%'){
        document.querySelector('.image-comparison__slider-wrapper').classList.add('AfterTxtActive');
        document.querySelector('.image-comparison__slider-wrapper').classList.remove('BeforeTxtActive');
      }
    }
    function init(element) {
        const sliderRange = element.querySelector('[data-image-comparison-range]');
        if ('ontouchstart' in window === false) {
            sliderRange.addEventListener('mouseup', e => setSliderstate(e, element));
            sliderRange.addEventListener('mousedown', moveSliderThumb);
        }else{
          sliderRange.addEventListener("touchstart", e => setSliderstate(e, element));
          sliderRange.addEventListener("touchend", e => setSliderstate(e, element));
          sliderRange.addEventListener("touchmove", e => moveSliderThumb);
        }
        sliderRange.addEventListener('input', e => moveSliderRange(e, element));
        sliderRange.addEventListener('change', e => moveSliderRange(e, element));
    }
    init(imageComparisonSlider);
  }
  
  var pauseIcon = document.querySelector('.stPrVideoPauseIcon');
  if(pauseIcon){
    pauseIcon.addEventListener('click',function(e){
      e.preventDefault();
      this.closest('.stPrVideo').querySelector('video').play();
      this.classList.add('hide');
    })
  }

  var FirstScreenOvrly = document.querySelector('.OverlayFirstScreen'), IFramePause = document.querySelector('.IFramePause');
  if(FirstScreenOvrly){
    FirstScreenOvrly.addEventListener('click',function(e){
      e.preventDefault();
      var IframSrc = this.closest('.fndVdMn').querySelector('.fndVdMnVideo iframe');
      var player = new Vimeo.Player(IframSrc);
      player.play();
      player.setMuted(0);
      this.closest('.fndVdMn').querySelector('.fndVdMnVideo').classList.add('VideoISPlaying');
      this.classList.add('hide');
    })
  }

  // if(IFramePause){
  //   IFramePause.addEventListener('click',function(e){
  //     e.preventDefault();
  //     console.log('Working')
  //     var IframSrc = this.parentNode.querySelector('iframe');
  //     var player = new Vimeo.Player(IframSrc);
  //     player.pause();
  //     player.setMuted(1);
  //     this.parentNode.classList.remove('VideoISPlaying');
  //     this.closest('.fndVdMn').querySelector('.OverlayFirstScreen').classList.remove('hide');
  //   })
  // }
  
})

